<template>
  <div class="flex-row">
    <Info :process="monitoringProcesss" @refresh="showLog" />
    <div class="timeline">
      <Timeline :lines="monitoringProcesss.logLines" />
    </div>
  </div>
</template>

<script>
import Service from '../../../../services/MonitoringCockpitService'
import Info from './Info.vue'
import Timeline from './Timeline.vue'

export default {
  name: 'ShowLog',

  data: () => ({
    monitoringProcesss: {
      status: '',
      startDateTime: '',
      endDateTime: '',
      logLines: []
    }
  }),

  components: { Info, Timeline },

  computed: {
    canShowLog () {
      const { processType, integrationID, date, monitoringID } = this.$route.query
      return processType && integrationID && date && monitoringID
    }
  },

  created () { this.showLog() },

  methods: {
    showLog () {
      if (!this.canShowLog) return console.error(this.$t('warnings.error.not_enough_data'))

      const { processType, integrationID, date, monitoringID } = this.$route.query
      Service.showLog(processType, integrationID, date, monitoringID)
        .then(response => { this.monitoringProcesss = response.data })
        .catch(error => console.error(this.$t('warnings.error.occurred'), error))
    }
  }

}
</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
}
.timeline {
  height: calc(100vh - 64px);
  overflow: auto;
  padding: 0 10px;
  width: 100%;
}
</style>
